/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_LeadsInputs */

const cs_nav_leads = /** @type {(inputs: Nav_LeadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leady`)
};

const en_nav_leads = /** @type {(inputs: Nav_LeadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leads`)
};

/**
* | output |
* | --- |
* | "Leads" |
*
* @param {Nav_LeadsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_leads = /** @type {((inputs?: Nav_LeadsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_LeadsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_leads(inputs)
	return cs_nav_leads(inputs)
});